import type { CSSProperties, ElementType, HTMLAttributes } from 'react'

import styles from './Stack.module.css'

/** Шаги шкалы отступов. Ни одного произвольного числа. */
export type Gap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16

export interface StackProps extends HTMLAttributes<HTMLElement> {
  /** Направление. По умолчанию колонка — вертикальный ритм основной. */
  row?: boolean
  gap?: Gap
  align?: CSSProperties['alignItems']
  justify?: CSSProperties['justifyContent']
  wrap?: boolean
  as?: ElementType
}

/**
 * Раскладка через gap, а не через margin у соседей.
 *
 * Это не стилистика: margin схлопывается, дублируется и оставляет
 * лишний отступ у последнего элемента. gap не делает ничего из этого.
 */
export function Stack({
  row = false,
  gap = 4,
  align,
  justify,
  wrap = false,
  as: Tag = 'div',
  className,
  style,
  ...rest
}: StackProps) {
  const classes = [styles.stack, row ? styles.row : styles.col, wrap ? styles.wrap : null, className]
    .filter(Boolean)
    .join(' ')

  return (
    <Tag
      className={classes}
      style={{ '--stack-gap': `var(--sp-${gap})`, alignItems: align, justifyContent: justify, ...style } as CSSProperties}
      {...rest}
    />
  )
}
